import initChoicesInstance from '../initChoicesInstance';
import filterRowsByInstrument from '../tables/filterRowsByInstrument';
import showTableById from '../tables/showTableById';
import animateTable from '../tables/animateTable';

document.addEventListener('DOMContentLoaded', (e) => {
  const instrumentChoice = document.querySelector('[data-instrument-choice]');
  const instrumentChoiceInstance = initChoicesInstance(instrumentChoice, {
    position: 'bottom',
  });

  const tabs = document.querySelectorAll('[data-tab]');

  tabs.forEach((el) => {
    el.addEventListener('click', (e) => {
      const { tab } = e.target.dataset;

      tabs.forEach((el) => el.classList.remove('is_active'));

      showTableById(tab);
      e.target.classList.add('is_active');

      const table = document.querySelector(`[data-table='${tab}']`);
      animateTable(table);
    });

  });

  instrumentChoice.addEventListener('choice', (e) => {
    const { id, value } = e.detail;

    const table = document.querySelector('[data-table]');
    const tbody = table.querySelector('tbody');
    const rows = [...tbody.rows];

    // Returns all rows, if the 'All' option was selected
    const filteredRows = id === 1 ? rows : filterRowsByInstrument(table, value);
    rows.forEach((row) => row.classList.add('hidden'));
    filteredRows.forEach((row) => row.classList.remove('hidden'));

    animateTable(table);
  });

});
